<script>
export default {
    name: 'ContentLine',
    props: {
        label: String,
        readonly: Boolean,
        icon: String,
        greenButton: Boolean,
    },
    methods: {
        edit() {
            this.$emit('edit')
        },
    },
}
</script>

<template lang="pug">
.content-line
    .form-row
        .align-items-center(:class="icon ? 'col-auto' : 'col-12 col-lg-3 col-xxl-2'")
            icon.w-md.text-73(v-if="icon" :icon="icon" size="lg")
            label.font-weight-semibold.font-size-base.mb-0(v-else-if="label") {{ $t(label) }}
        .col.align-items-center(aria-hidden="true")
            span.content
                slot
        .col-auto.align-items-center.justify-content-end(v-if="!readonly && !$slots.content")
            button.btn.btn-icon.rounded-circle(@click="edit" :class="greenButton ? 'btn-white-primary' : 'btn-transparent'")
                icon(icon="fa-solid fa-pencil-alt")
</template>
